import axios from 'axios';
import { CapacitorUpdater } from '@capgo/capacitor-updater';
import { Dialog } from '@capacitor/dialog';
import { Toast } from '@capacitor/toast';

import { default as appHelper } from './helper.capacitor';


axios.defaults.baseURL = appHelper.getBaseApiUrl();



const appIsReady = async () => {
  return await CapacitorUpdater.notifyAppReady();
};

const getAppVersion = async () => {
  const appIn = (await appHelper.appInfo()) || {};
  const { id, build, version } = appIn;

  const current = await CapacitorUpdater.current();
  const { version: bundleVersion2 } = current.bundle;
  const bundlVersion = bundleVersion2 != 'builtin' ? bundleVersion2 : version;
  const bundlBuild =
    bundleVersion2 != 'builtin'
      ? Number(bundlVersion.replaceAll('.', ''))
      : build;

  const result = await axios
    .post(`auth/control/${version}`, { isApp: true })
    .then(res => res.data);

  let resultVersion = version;
  let resultBuild = build;
  let newVerstion = version;
  let newBuild = build;

  const compareBuild = version.split('.');
  const compareBundlBuild = bundlVersion.split('.');
  const compareNewBundlBuild = result?.currentVersion.split('.');

  let needUpdate = false;

  if (
    // compareBundlBuild < compareNewBundlBuild &&
    Number(compareBundlBuild[0]) < Number(compareNewBundlBuild[0]) || // 1st less
    (Number(compareBundlBuild[0]) == Number(compareNewBundlBuild[0]) && // 1st same
      Number(compareBundlBuild[1]) < Number(compareNewBundlBuild[1])) || // 2nd less
    (Number(compareBundlBuild[0]) == Number(compareNewBundlBuild[0]) && // 1st same
    Number(compareBundlBuild[1]) == Number(compareNewBundlBuild[1]) && // 2nd same
      Number(compareBundlBuild[2]) < Number(compareNewBundlBuild[2])) // 3rd less
  ) {
    resultBuild = bundlBuild;
    resultVersion = bundlVersion;
    newVerstion = result?.currentVersion;
    newBuild = result?.currentBuild;
    needUpdate = true;
  } else {
    if (
      // compareBuild == compareBundlBuild &&
      Number(compareBuild[0]) == Number(compareBundlBuild[0]) &&
      Number(compareBuild[1]) == Number(compareBundlBuild[1]) &&
      Number(compareBuild[2]) == Number(compareBundlBuild[2])
    ) {
      resultBuild = build;
      resultVersion = version;
      newVerstion = result?.currentVersion;
      newBuild = result?.currentBuild;
    } else if (
      // compareBuild < compareBundlBuild &&
      Number(compareBuild[0]) < Number(compareBundlBuild[0]) || // 1st less
      (Number(compareBuild[0]) == Number(compareBundlBuild[0]) && // 1st same
        Number(compareBuild[1]) < Number(compareBundlBuild[1])) || // 2nd less
      (Number(compareBuild[0]) == Number(compareBundlBuild[0]) && // 1st same
      Number(compareBuild[1]) == Number(compareBundlBuild[1]) && // 2nd same
        Number(compareBuild[2]) < Number(compareBundlBuild[2])) // 3rd less
    ) {
      resultBuild = bundlBuild;
      resultVersion = bundlVersion;
      newVerstion = result?.currentVersion;
      newBuild = result?.currentBuild;
    }
  }

  const final = {
    version: resultVersion,
    build: resultBuild,
    newBuild: newBuild,
    newVersion: newVerstion,
    needUpdate,
  };
  // console.debug(`run bundle final!`, JSON.stringify(final));
  return final;
};

const checkAndUpdateApp = async (logOutFn) => {

  const appIn = (await appHelper.appInfo()) || {};
  const { id, build, version } = appIn;

  if (!!version) {
    const currentBundl = await getAppVersion();
    const result = await axios
      .post(`auth/control/${version}`, { isApp: true })
      .then(res => res.data);
    if (currentBundl?.needUpdate) {
      await checkAndUpdate({
        url: result?.url,
        version: result?.currentVersion,
      }, logOutFn);
    } else {
      Toast.show({
        text: `The current version is up to date`,
        duration: 'short',
      });
    }
    return { ...result, ...appIn };
  } else {
    Toast.show({
      text: `The current version is up to date`,
      duration: 'short',
    });
    return appIn;
  }
};

const checkAndUpdate = async (props, logOutFn) => {
  const { url, version } = props;
 // console.debug('run checkAndUpdate:', JSON.stringify(props));
  const canAutoUpdate = await CapacitorUpdater.isAutoUpdateEnabled().then(r => r?.enabled);
 // console.debug('run canAutoUpdate:', JSON.stringify( canAutoUpdate));
//  console.debug('run appHelper.getBaseApiUrl():', JSON.stringify( appHelper.getBaseApiUrl()));
  if (!!canAutoUpdate) {
    if (!!url) {
       // Show an alert to the user asking if they want to update
      const { value } = await Dialog.confirm({
        title: 'Confirm',
        message: `A new update is available, do you want to download it now?`,
      });
      
      if (!!value) {
        // logout before update
        !!logOutFn && logOutFn();
        // Start the download
        CapacitorUpdater.download({
          url,
          version
        }).then((BundleInfo) => {
          CapacitorUpdater.set(BundleInfo); 
        });
      }
    } else {
      Toast.show({
        text: `File download error, please try again later.`,
        duration: 'short',
      });
    }
  } else {
    console.debug('run checkAndUpdate Error: isAutoUpdateEnabled is disabled');
  }
}

/* 
BundleInfo:
  id:	string
  version:	string
  downloaded:	string
  checksum:	string
  status:	"success" | "error" | "pending" | "downloading"
*/

const appDownloadComplete = (bundle) => {
  // console.debug(`appDownloadComplete!`, JSON.stringify(bundle));
  Toast.show({
    text: "Update downloaded, the app will now reload",
    duration: 'short',
  });
  // Reload the app to apply the update
  CapacitorUpdater.reload();
};

const appDownloading = (info, setProgressPercent) => {
  const { percent, bundle } = info;
  /* console.debug(`Download progress: ${percent}`, percent > 0 && percent != 100); */
  // Show the download progress as a toast
  setProgressPercent(percent);
  if ( percent == 0 ) {
    // Show the updated download progress as a toast
    Toast.show({
      text: `Downloading is started... Please wait a moment!`,
      duration: 'short',
    });
  }
  
};

const appDownloadFailed = async (version) => {
  //console.debug(`appDownloadFailed!`, JSON.stringify(version));
  Toast.show({
    text: `File download error, please try again later.`,
    duration: 'short',
  });
};
const appNoNeedUpdate = async (bundle) => {
  const currentBundl = await getAppVersion();
  // console.debug(`apppNoNeedUdate!`, JSON.stringify(bundle));
//console.debug(`appNoNeedUpdate! currentBundl`, JSON.stringify(currentBundl));
  if (currentBundl?.needUpdate) { 
    checkAndUpdateApp();
  }
};

const appUpdateAvailable = async (bundle) => {
  //const { version, status, downloaded, id, checksum } = bundle;
 // const currentBundl = await getAppVersion();
  // console.debug(`appUpdateAvailable!`, JSON.stringify(bundle));
  // console.debug(`appUpdateAvailable! currentBundl`, JSON.stringify(currentBundl));
};
const appReloadedCallback = async (bundle) => {
  //console.debug(`appReloadedCallback!`, JSON.stringify(bundle));
  // Delete the downloaded zip archive
  CapacitorUpdater.delete();
};

export default {
  getAppVersion,
  checkAndUpdateApp,
  appIsReady,
  checkAndUpdate,
  appDownloadComplete,
  appDownloading,
  appDownloadFailed,
  appNoNeedUpdate,
  appUpdateAvailable,
  appReloadedCallback
}